<template>
  <div>
    <button
      :class="buttonClass + ' d-print-none'"
      :style="buttonStyle"
      @click="$emit('buttonInput')"
    >
      {{buttonText}}
    </button>
    <a :href="urlLink">
      <button
        :class="buttonClass + ' hidden-normal'"
        :style="buttonStyle"
      >
        {{buttonText}}
      </button>
    </a>
  </div>
</template>
<script>
export default {
  name: "PDFButton",
  props: {
    buttonClass: { String },
    buttonStyle: { String, default: "" },
    urlLink: { String },
    buttonText: { String },
  },
};
</script>
<style>
.hidden-normal {
  display: none;
}
@media print {
  .no-pagebreak {
    break-inside: avoid-page;
  }
  .no-print,
  .no-print * {
    display: none;
  }
  .hidden-normal {
    display: inline;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/PDFButton.vue